import { useTranslate } from "ra-core";
import { AuthShell } from "./AuthShell";

export const ConfirmationRequired = () => {
  const translate = useTranslate();

  return (
    <AuthShell
      title={translate("crm.auth.welcome_title", {
        _: "Welcome to Mimin",
      })}
    >
      <p className="text-center text-sm text-muted-foreground">
        {translate("crm.auth.confirmation_required", {
          _: "Please follow the link we just sent you by email to confirm your account.",
        })}
      </p>
    </AuthShell>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
